import HttpFactory from '../HttpFactory'
import type IBasicObjectResponse from '../interfaces/IBasicObjectResponse'
import type PriceCalculatorParams from '~/types/price-calculator/PriceCalculatorParams'

class PriceCalculatorModule extends HttpFactory {
  private RESOURCE = 'services/price-calculator'

  async getPriceCalculation (objektNr: number, params: PriceCalculatorParams) {
    return await this.callUseFetch<IBasicObjectResponse>(
      'POST',
      `${this.RESOURCE}/${objektNr}`,
      {
        params
      },
      {
        'Content-Type': 'application/json'
      },
      {
        server: false,
        immediate: false,
        watch: false,
        transform: (data: any) => {
          /*
          TODO: Remove the "if (data.data) { return data.data }".
          This is meant to be temporary during my development for ticket #25225,
          because I change the response of the price calculatur from Json::simpleResponse() to Json::response()
          */
          if (data.data !== undefined) {
            data.data.debug = data.debug
            return data.data
          }

          return data
        },
        onResponse ({ response }: any) {
          if (typeof response._data === 'string' && response._data.includes('xdebug')) {
            throw new Error(
              `Error in price calculator after calling it for object ${objektNr} with params "${JSON.stringify(params)}"\n\n${response._data}`
            )
          }
        }
      }
    )
  }
}

export default PriceCalculatorModule
